import { render, staticRenderFns } from "./MgrupoenvasadoModals.vue?vue&type=template&id=ff3b6db8"
import script from "./MgrupoenvasadoModals.vue?vue&type=script&lang=js"
export * from "./MgrupoenvasadoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports